import { CancelPendingLessonsInput, Lesson } from "@hubcapp/types";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import cancelPendingLessonsMutation from "../graph-ql/cancelPendingLessons.graphql";

const useCancelPendingLessons = (
  opts: MutationHookOptions<
    {
      cancelPendingLessons: Lesson[];
    },
    {
      input: CancelPendingLessonsInput;
    }
  > = {},
) =>
  useMutation(cancelPendingLessonsMutation, {
    ...opts,
  });

export default useCancelPendingLessons;
